export default "__VITE_ASSET__D0CcMI1V__"